import React, { useState, useEffect } from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

const typeClasses = {
    success: {
        toast: 'border-success',
        header: 'bg-success text-white'
    },
    danger: {
        toast: 'border-danger',
        header: 'bg-danger text-white'
    },
    warning: {
        toast: 'border-warning',
        header: 'bg-warning text-dark'
    },
    info: {
        toast: 'border-info',
        header: 'bg-info text-white'
    }
};

const EdgeToast = ({ type, title, content, isOpen, toggle }) => {
    const [toastClasses, setToastClasses] = useState({ toast: '', header: '' });

    useEffect(() => {
        const classes = typeClasses[type] || typeClasses.info;
        setToastClasses(classes);
    }, [type]);

    if (!isOpen) {
        return null;
    }

    return (
        <Toast className={`edge-toast ${toastClasses.toast}`}>
            <ToastHeader className={toastClasses.header} toggle={toggle}>
                {title}
            </ToastHeader>
            <ToastBody>{content}</ToastBody>
        </Toast>
    );
}

export default EdgeToast;
